import React, { useState } from "react";
import { GoldenSourceHelper } from "../../../../app/Switch_Core_React_Standards";
// 🎯 FIX: Alias to UserMatrix (PascalCase)
import UserMatrix from "../Matrix/SEC_03_UserMatrixController"; 

export default function SEC_03_UserManagementView({ users, isSubmitting, onSearch }) {
  const [expandedUserId, setExpandedUserId] = useState(null);

  if (isSubmitting) {
    return <div className="p-5 text-center text-muted small italic">Refreshing user directory...</div>;
  }

  return (
    <div className="p-4 animate__animated animate__fadeIn">
      <div className="table-responsive">
        <table className="table table-hover align-middle mb-0">
          <thead className="bg-light">
            <tr className="extra-small text-uppercase text-muted">
              <th className="ps-3 border-0">User Name</th>
              <th className="border-0">Email Address</th>
              <th className="text-end pe-3 border-0">Matrix</th>
            </tr>
          </thead>
          <tbody>
            {users && users.length > 0 ? users.map((user, idx) => {
              const userGuid = GoldenSourceHelper.get(user, "SiteUserGuid");
              const isExpanded = expandedUserId === userGuid;

              return (
                <React.Fragment key={idx}>
                  <tr 
                    onClick={() => setExpandedUserId(isExpanded ? null : userGuid)}
                    style={{ cursor: "pointer" }}
                    className={isExpanded ? "table-active" : ""}
                  >
                    <td className="ps-3 small fw-bold">
                      {GoldenSourceHelper.get(user, "userName") || "N/A"}
                    </td>
                    <td className="small text-muted">
                      {GoldenSourceHelper.get(user, "emailAddress")}
                    </td>
                    <td className="text-end pe-3">
                      <button className="btn btn-link btn-sm extra-small fw-bold p-0 text-decoration-none">
                        {isExpanded ? "CLOSE" : "EXPAND"}
                      </button>
                    </td>
                  </tr>

                  {isExpanded && (
                    <tr>
                      <td colSpan="3" className="p-0 border-0 bg-white shadow-inner">
                        {/* 🎯 Using PascalCase Alias */}
                        <UserMatrix targetUserGuid={userGuid} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            }) : (
              <tr>
                <td colSpan="3" className="text-center py-5 text-muted small italic">
                  No users found in the current landscape.
                </td>
              </tr>
            )}
            
            {/* Standardized Add Trigger */}
            <tr className="table-light border-top">
              <td colSpan="2" className="ps-3 extra-small text-muted italic">
                Invite a new user to the platform...
              </td>
              <td className="text-end pe-3">
                <button className="btn btn-xs btn-outline-secondary p-0 px-1 border-dotted" style={{ fontSize: "10px" }}>
                  +
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}